const StudentDetails = () => {
    return (
        <div id="student" className="vision-card">
            <h3>STUDENT DETAILS</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th>CLASS</th>
                            <th>TOTAL NUMBER OF SECTIONS</th>
                            <th>TOTAL NUMBER OF STUDENTS</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr><td>1</td><td>3</td><td>18</td></tr>
                        <tr><td>2</td><td>3</td><td>20</td></tr>
                        <tr><td>3</td><td>3</td><td>25</td></tr>
                        <tr><td>4</td><td>3</td><td>27</td></tr>
                        <tr><td>5</td><td>3</td><td>26</td></tr>
                        <tr><td>6</td><td>3</td><td>29</td></tr>
                        <tr><td>7</td><td>3</td><td>24</td></tr>
                        <tr><td>8</td><td>3</td><td>14</td></tr>
                        <tr><td>9</td><td>Total</td><td>183</td></tr>
                        
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default StudentDetails;